export const containerCss = "c1s3f46h";
export const titleCss = "tc3fb66";
export const descriptionCss = "d7syfwh";

require("./index.style.linaria.module.css");